import {useEffect, useMemo} from 'react';

export default function useTitle(title: string, prefix: boolean = true): void {
	const titleValue = useMemo(() => {
		return (prefix ? 'Inventory Hub | ' : '') + title;
	}, [title, prefix]);

	useEffect(() => {
		const previous = document.title;
		document.title = titleValue;

		return () => {
			document.title = previous;
		};
	}, [titleValue]);
}
